import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {OphBackButtonComponent} from 'src/app/shared/design/oph-back-button/oph-back-button.component';

export interface CsSharedHeaderTab {
  value: string;
  label: string;
}

@Component({
  selector: 'cs-shared-header',
  standalone: true,
  imports: [OphBackButtonComponent],
  templateUrl: './cs-shared-header.component.html',
  styleUrl: './cs-shared-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsSharedHeaderComponent {
  readonly label = input<string | null | undefined>('');
  readonly tabs = input<CsSharedHeaderTab[]>([]);
  readonly selectedTab = input<string | null | undefined>('');

  readonly backClick = output<void>();
  readonly tabChange = output<string>();
  readonly tabChangeDirection = output<'left' | 'right'>();

  onTabClick(tab: CsSharedHeaderTab): void {
    if (tab.value === this.selectedTab()) return;
    const currentIndex = this.tabs().findIndex(t => t.value === this.selectedTab());
    const newIndex = this.tabs().indexOf(tab);
    this.tabChangeDirection.emit(newIndex > currentIndex ? 'right' : 'left');
    this.tabChange.emit(tab.value);
  }
}
